export const ABTestingScenarios = {
  Pricing: {
    Default: 'default',
    ScenarioB: 'scenario_b'
  },
  StockShortage: {
    A: 'a',
    B: 'b'
  },
  LandingPage: {
    Default: 'default',
    ScenarioB: 'scenario_b'
  }
};
